<template>
    <section class="content" v-if="carregou">
        <div class="row">
            <div class="col-sm-12">
                <box title="Dados do Cliente">
                    <div slot="body" class="bodyBox">
                        <div>
                            <label for="">Cliente: </label> {{solicitacao.Clientes.nome}} {{solicitacao.Clientes.sobrenome}} <br>
                            <label for="">Email: </label> {{solicitacao.Clientes.email}} <br>
                            <label for="">Contato: </label> {{solicitacao.Clientes.contato}} <br>
                            <!-- <label for="">Facebook ID: </label> {{solicitacao.Clientes.facebookid}} <br> -->
                            <label for="">Preferência de contato: </label> {{solicitacao.Preferencias[0].tipo}} <br>
                            <label for="">Horário para contato: </label> {{solicitacao.Preferencias[0].horario}} <br>
                        </div>

                    </div>
                </box>
            </div>
            <!-- <div class="col-sm-6">
                <box title="Interesses"><br>
                    <div slot="body" class="bodyBox" style="text-align: center;">
                        <span class = "badge" v-for="filtro in solicitacao.SolicitacoesHasFiltros">#{{filtro.resposta}}</span>
                    </div>
                </box>
            </div> -->
        </div>
        <div class="row" v-if="solicitacao.tipo === 'personalizado'">
            <div class="col-sm-12">
                <!-- <box title="Perguntas Personalizadas" >
                    <div class="" slot="body">
                        <div v-for="pergunta in solicitacao.PerguntasRespostas">
                            <label for="">{{pergunta.PerguntasPersonalizadas.pergunta}}: </label> {{pergunta.resposta}}
                        </div>
                    </div>
                </box> -->
                <box title="Interesses" >
                    <div class="" slot="body">
                        <div v-for="pergunta in solicitacao.SolicitacoesHasFiltros" class="" style="margin-bottom: 1em; display: flex">
                            <label for="">{{pergunta.Filtros.descricao}}: </label><h4 class="resposta">{{pergunta.filtrosid === solicitacao.RespostasAdicionais[0].filtrosid ? `${pergunta.resposta} (${solicitacao.RespostasAdicionais[0].resposta})` : pergunta.resposta}} </h4>
                        </div>
                    </div>
                </box>
            </div>
        </div>
        <div class="row" v-if="solicitacao.tipo === 'pacote'">
            <div class="col-sm-12">
                <box title="Pacote de Viagem" >
                    <div class="row" slot="body">
                        <div class="col-sm-12 table-responsive">
                        <table aria-describedby="example2_info" role="grid" id="example2" class="table table-borde#F48668 table-striped dataTable">
                            <thead>
                            <tr>
                                <th v-for="coluna in colunas">
                                    <div class="row">
                                        <div class="col-sm-7">
                                        {{coluna }}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr class="even" role="row">
                                    <td>{{solicitacao.Pacotes.id}}</td>
                                    <td>{{solicitacao.Pacotes.titulo}}</td>
                                    <td>{{solicitacao.Pacotes.descricao}}</td>
                                    <td>{{solicitacao.Pacotes.qtdepessoas}}</td>
                                    <td>{{solicitacao.Pacotes.preco}}</td>
                                </tr>             
                            </tbody>
                            <tfoot>
                            </tfoot>
                        </table>
                        </div>
                    </div>
                </box>
            </div>
        </div>

        <div class="row" v-if="solicitacao.tipo === 'pacote'">
            <div class="col-sm-12">
                <box title="Dados Pagamento" >
                    <div class="row" slot="body">
                        <div class="col-sm-12 table-responsive">
                        <table aria-describedby="example2_info" role="grid" id="example2" class="table table-borde#F48668 table-striped dataTable">
                            <thead>
                            <tr>
                                <th v-for="coluna in colunasPgto">
                                    <div class="row">
                                        <div class="col-sm-7">
                                        {{coluna}}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr class="even" role="row">
                                    <td>{{solicitacao.Pagamentos[0].nome}}</td>
                                    <td>{{solicitacao.Pagamentos[0].numero}}</td>
                                    <td>{{solicitacao.Pagamentos[0].vencimento}}</td>
                                    <td>{{solicitacao.Pagamentos[0].codigo}}</td>
                                </tr>             
                            </tbody>
                            <tfoot>
                            </tfoot>
                        </table>
                        </div>
                    </div>
                </box>
            </div>
        </div>

        <div class="row" v-if="solicitacao.tipo === 'pacote'">
            <div class="col-sm-12">
                <box title="Dados Passageiros" >
                    <div class="row" slot="body">
                        <div class="col-sm-12 table-responsive">
                        <table aria-describedby="example2_info" role="grid" id="example2" class="table table-borde#F48668 table-striped dataTable">
                            <thead>
                            <tr>
                                <th v-for="coluna in colunasPassageiros">
                                    <div class="row">
                                        <div class="col-sm-7">
                                        {{coluna}}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr class="even" role="row" v-for="passageiro in solicitacao.DadosPassageiros">
                                    <td>{{passageiro.nome}}</td>
                                    <td>{{passageiro.cpf}}</td>
                                    <td>{{passageiro.contato}}</td>
                                    <td>{{passageiro.email}}</td>
                                </tr>             
                            </tbody>
                            <tfoot>
                            </tfoot>
                        </table>
                        </div>
                    </div>
                </box>
            </div>
        </div>
    </section>
</template>

<script>
import Box from '../Box'
import resource from './resource'

export default {
  name: 'Pedidos',
  components: {
    'box': Box,
  },
  data () {
    return {
        solicitacao: null,
        carregou: false,
        colunas: [
                'id',
                'Título',
                'Descricao',
                'Quantidade de Passageiros',
                'Preço'
        ],
        colunasPgto: ['Nome', 'Número do cartão', 'Vencimento', 'CVV'],
        colunasPassageiros: ['Nome', 'CPF', 'Contato', 'E-mail']
    }
  },
  created() {
      this.getSolicitacao(this.$route.params.id)
  },
  methods: {
      getSolicitacao(id) {
          resource.getSolicitacao(id).then(res => {
              this.solicitacao = res.data
              console.log('solicitacao ==> ', this.solicitacao)
              this.carregou = true
          })
      }
  },
}
</script>
<style scoped>
.badge {
    background: #3C8DBC;
    font-size: 1.3em;
    margin: 5px
}
.bodyBox {
        /* height: 8.5em; */
    /* margin-bottom: 3em; */

}
.resposta {
    font-size: 18px;
    /* margin-left: 1em; */
    margin: 0 0 0 1em
}
</style>



// WEBPACK FOOTER //
// detalhe.vue?7b4f5f41